/**
 * Networks Page Logic
 *
 * Admin network/bridge management page
 */

import { initAuthenticatedPage, hasPermission } from '../app/init.js';
import { fillBridgesTable } from '../admin/networks.js';
import { declareLoading, notificationDialog } from '../ui/dialogs.js';

/**
 * Initialize the networks page
 */
export async function initNetworksPage(): Promise<void> {
  const user = await initAuthenticatedPage();
  if (!user) return; // Will redirect to login

  // Check admin permission
  if (!hasPermission('admin')) {
    notificationDialog('Access denied: Admin permission required');
    window.location.href = '/';
    return;
  }

  // Load bridges table
  declareLoading();
  try {
    await fillBridgesTable();
    // Show content after table is ready
    const content = document.getElementById('content');
    if (content) content.style.display = 'block';
  } catch (error) {
    const msg = error instanceof Error ? error.message : 'Failed to load networks';
    notificationDialog(msg);
  }
}

// Export to window for onclick handlers
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).initNetworksPage = initNetworksPage;
}
